import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section id="categories" className="py-16 md:py-24 px-4 md:px-6 bg-background-100" aria-labelledby="categories-title">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs md:text-sm text-accent-600 font-semibold tracking-[0.2em] uppercase mb-3">
            内容分类
          </p>
          <h2 id="categories-title" className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            找到你的行动力入口
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            五个维度，覆盖行动力觉醒的每一个方面。选择一个方向，开始你的蜕变之旅。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/80 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-accent-600 font-medium bg-accent-100 px-3 py-1 rounded-full group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                {cat.count} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}